import { useQuery } from '@tanstack/react-query';

import { useApiClient } from '../context';
import { queryKeys } from '../queryKeys';

export function useMeRestaurants() {
  const client = useApiClient();
  return useQuery({
    queryKey: queryKeys.meRestaurants(),
    queryFn: ({ signal }) => client.listMeRestaurants({}, { signal }),
  });
}

export function useMeStats() {
  const client = useApiClient();
  return useQuery({
    queryKey: queryKeys.meStats(),
    queryFn: ({ signal }) => client.getMeStats({}, { signal }),
  });
}

export function useMeAddresses() {
  const client = useApiClient();
  return useQuery({
    queryKey: queryKeys.meAddresses(),
    queryFn: ({ signal }) => client.listMeAddresses({}, { signal }),
  });
}
